import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  assignAssetsToUserThunk,
  getAllAssetsThunk,
} from "../../Store/Thunks/ListingAssetsThunk";
import { Space, Table, Button } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";

const UserAssets = ({ userId }) => {
  const dispatch = useDispatch();
  const userAssetsList = useSelector(
    (state) => state.ListingAssetsReducer.userAssetsList,
  );

  const [assetsState, setAssetsState] = useState([]);
  const [initialAssetsState, setInitialAssetsState] = useState([]);
  const [isBulkAction, setIsBulkAction] = useState(false);

  useEffect(() => {
    if (userId) {
      dispatch(getAllAssetsThunk(parseInt(userId)));
    }
  }, [userId]);

  useEffect(() => {
    if (userAssetsList?.length) {
      const normalized = userAssetsList.map((item) => ({
        ...item,
        show: item.listingAssetsUserInfo?.show || false,
      }));

      setAssetsState(normalized);
      setInitialAssetsState(normalized);
    }
  }, [userAssetsList]);

  const handleCheckboxChange = (id, checked) => {
    setIsBulkAction(false);

    setAssetsState((prev) =>
      prev.map((item) => (item.id === id ? { ...item, show: checked } : item)),
    );
  }; 

  const handleSave = () => {
    let formattedList = [];

    if (isBulkAction) {   
      formattedList = assetsState.map((item) => ({
        id: item.id,
        show: item.show,
      }));
    } else {  
      const changedItems = assetsState.filter((item) => {
        const original = initialAssetsState.find((init) => init.id === item.id);
        return original && original.show !== item.show;
      });

      formattedList = changedItems.map((item) => ({
        id: item.id,
        show: item.show,
      }));
    }

    if (formattedList.length > 0) {
      dispatch(assignAssetsToUserThunk(formattedList, userId));
    }
  };
  const handleSelectAll = (checked) => {
    setIsBulkAction(true);

    setAssetsState((prev) =>
      prev.map((item) => ({
        ...item,
        show: checked,
      })),
    );
  };
  const allSelected =
    assetsState.length > 0 && assetsState.every((item) => item.show);
  const someSelected = assetsState.some((item) => item.show) && !allSelected;

  const columns = [
    {
      title: "#",
      key: "index",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Asset",
      dataIndex: "assetName",
      key: "assetName",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Asset Slug",
      dataIndex: "assetSlug",
      key: "assetSlug",
      width: 250,
      ellipsis: true,
    },
    {
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <span>Actions</span>
          <div>
            <Checkbox
              indeterminate={someSelected}
              checked={allSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
            <span style={{ marginLeft: 10 }}>Select/Unselect</span>
          </div>
        </div>
      ),
      width: 150,
      render: (_, record) => (
        <Space size="small">
          <Checkbox
            className="custom-checkbox"
            checked={record.show || false}
            onChange={(e) => handleCheckboxChange(record.id, e.target.checked)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleSave}>
          Assign Changes
        </Button>
      </Space>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={assetsState}
        pagination={false}
        scroll={{ y: 500 }}
      />
    </>
  );
};

export default UserAssets;
